module.exports = __webpack_public_path__ + "static/media/blueshape2.ec84ed01.png";